import { useQuery } from "react-query";
import axios from "infra/http";

function usePessoaUnidadesVoto(id: string) {
  return useQuery(
    [`/v1/pessoas/${id}/unidades`],
    async () => {
      const res = await axios.get<string[]>(`/v1/pessoas/${id}/unidades-voto`);

      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}

export default usePessoaUnidadesVoto;
